import {ExcludeMicaList} from '../../types/interfaces/configuration';


export class FetchExcludeMica {
  static readonly type = '[excludeMica] Fetch All';

  constructor(public payload: ExcludeMicaList[]) {
  }
}
